define(function(require,exports,module) {
    var tpl =   
            '<% if(pageNum == 1) { %>' +
                '<div class="mask hide">' +
                    '<img src="//static.360buyimg.com/globalwide/dist/v20160412/i/loading.gif">' +
                    '<div class="nomore-tip hide">该类目暂无商品展示</div>' +
                '</div>' +
            '<% } %>' +
            '<% for(i = 0; i < goods.length; i++) { %>'+
                '<a skuid = "<%= goods[i].skuText %>" ' +
                       'class="block tapItem"' +
                       'clstag="<%== goods[i].clsTag %>">' +
                    '<% if(goods[i].imgLogo) { %>' +
                        '<img src="" class="conner lazy" dataimg="<%== goods[i].imgLogo %>">' +
                    '<% } %>' +
                    '<img src="" class="m-img lazy" dataimg="<%== goods[i].skuImg %>">' +
                    '<div class="compare hide">比PC端省<span class="num"> </span>元</div>' +
                    '<div class="name"><%== goods[i].itemText %></div>' +
                    '<div class="price">' +
                        '<span></span>' +
                    '</div>' +
                '</a>' +
            '<% } %>'
    exports.tpl = tpl;
});


// WEBPACK FOOTER //
// ./src/js/template/gatherLoadMore.js